<template>
	<li :class="className">
		<a
			:href="url"
			:target="target"
			:rel="rel"
			class="no-submenu link-menu"
			:class="className"
			@click="clicked"
			v-html="title"
		>
			<img
				v-if="imagePath"
				:src="imagePath"
				:alt="title"
				:class="className"
			/>
		</a>
	</li>
</template>
<script>
export default {
	name: 'Link',
	props: {
		title: String,
		url: { type: String, default: '#' },
		target: { type: String, default: '_self' },
		rel: { type: String, default: 'noopener noreferrer' },
		image: { type: String, default: null },
		className: { type: String, default: '' },
		method: String,
	},
	computed: {
		imagePath() {
			return this.image
				? require('../../assets/img/' + this.image)
				: false
		},
	},
	methods: {
		clicked() {
			if (this.method) {
				this.$emit(this.method)
			}
		},
	},
}
</script>

<style scoped lang="scss">
a {
	color: $gray2Theme;

	&.top-navbar {
		color: $white;
		font-size: 13px;
		margin-left: 14px;
	}

	&.social {
		display: block;
		background-image: url($pathToAssets+'/img/sprite-social.png');
		background-repeat: no-repeat;
		width: 32px;
		height: 32px;
		margin-left: 2px;
	}

	&.twitter {
		background-position: 0 -32px;
	}

	&.linkedin {
		background-position: 0 -64px;
	}

	&.instagram {
		background-position: 0 -96px;
	}

	&.footer {
		color: $gray5Theme;
	}

	&[href^='mailto:'],
	&.active {
		color: $greenTheme;
	}
}

@include nomobile {
	li {
		a {
			&:hover,
			&:focus {
				color: $black !important;

				&.footer {
					color: $greenTheme !important;
				}
			}
		}
	}
}
</style>
